import React from 'react';

const JsonLD = ({ structuredData }: { structuredData?: Record<string, any> }) =>
  structuredData ? (
    <script
      type='application/ld+json'
      dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
    />
  ) : null;

export default JsonLD;
